export default __webpack_public_path__ + "static/media/3m.cbac183e.svg";